import React, { PureComponent } from 'react';
import { Tabs } from 'antd';
import cn from 'classnames';

import PropTypes from 'prop-types';
import Immutable from 'immutable';

import MenuItem from './MenuItem';

import styles from './menu.less';

const { TabPane } = Tabs;

class BaseMenuList extends PureComponent {
  static propTypes = {
    items: PropTypes.object,
  };

  getOrderFromItems = (items = this.props.items) => items.toList().map((item) => item.key);

  state = {
    order: this.getOrderFromItems(),
    dropdownMenuItems: Immutable.List(),
    itemId: null,
    afterItemId: null,
  };

  componentDidUpdate(prevProps) {
    const nextOrder = this.getOrderFromItems(this.props.items);
    const prevOrder = this.getOrderFromItems(prevProps.items);

    if (!Immutable.is(nextOrder, prevOrder)) {
      this.setState({
        order: nextOrder,
      });
    }
  }

  onDrop = (dragItem, dropItem) => {
    // save
    const newOrderList = this.state.order.toArray();
    this.props.onDrop && this.props.onDrop(dragItem, dropItem, newOrderList);
  };

  onMoveItem = (dragItem, dropItem) => {
    if (dragItem.dragType == dropItem.dragType) {
      const itemId = dragItem.key;
      const afterItemId = dropItem.key;

      if (itemId !== this.state.itemId || afterItemId !== this.state.afterItemId) {
        // get dragging item
        const findIndex = (id) => this.state.order.findIndex((key) => key === id);
        const dragItemIndex = findIndex(itemId);
        const realDragItem = dragItemIndex !== -1 ? this.state.order.get(dragItemIndex) : dragItem.key;

        // reorder
        let arr = this.state.order;
        // remove from old position if from this list
        if (dragItemIndex !== -1) {
          arr = arr.delete(dragItemIndex);
        }
        // add item to new position
        arr = arr.insert(findIndex(afterItemId), realDragItem);

        // save to local
        this.setState({
          order: arr,
          itemId,
          afterItemId,
        });
      }
    }
  };

  onRemoveItem = (dragItem) => {
    const itemId = dragItem.key;
    const findIndex = (id) => this.state.order.findIndex((key) => key === id);
    const dragItemIndex = findIndex(itemId);

    // save in local state
    const arr = this.state.order.delete(dragItemIndex);
    this.setState({
      order: arr,
    });

    // save order
    const newOrderList = arr.toArray();
    this.props.onRemoved && this.props.onRemoved(dragItem, null, newOrderList);
  };

  render() {
    const {
      listId,
      activeId,
      dragType,
      canDrag,
      canDrop,
      tabPosition,
      direction,
      className,
      popupClassName,
      itemClassName,
    } = this.props;

    const { items } = this.props;
    const { order } = this.state;
    const itemsByKey = Immutable.Map(items.toList().map((item) => [item.key, item]));
    const orderedItems = order
      .map((key) => itemsByKey.get(key))
      .filter(Boolean)
      .concat(items.filter((item) => !order.includes(item.key)));

    return (
      <Tabs
        listId={listId}
        className={cn(
          styles.menu,
          {
            [styles.menuHorizontal]: direction === 'row',
            [styles.menuVertical]: direction === 'column',
          },
          className,
        )}
        popupClassName={popupClassName}
        tabPosition={tabPosition}
        activeKey={activeId}
      >
        {orderedItems.map((item) => (
          <TabPane
            listId={listId}
            tab={
              <MenuItem
                listId={listId}
                key={item.key}
                item={item}
                dragType={dragType}
                canDrag={canDrag}
                canDrop={canDrop}
                onMoveItem={this.onMoveItem}
                onRemoveItem={this.onRemoveItem}
                onDrop={this.onDrop}
                className={cn(styles.item, itemClassName)}
              />
            }
            key={item.key}
          />
        ))}
      </Tabs>
    );
  }
}

export default BaseMenuList;
